export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WHATSAPP_COMMUNITY_URL =
  "https://wa.me/919164554111?text=Hi%20Pranivaa!%20I%20want%20to%20join%20the%20community.";

export const INSTAGRAM_URL = "https://instagram.com/pranivaakitchens";

export const IMAGES = {
  heroThali:
    "https://images.unsplash.com/photo-1742281258189-3b933879867a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  freshSalad:
    "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  saladGrid:
    "https://images.unsplash.com/photo-1600335895229-6e75511892c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  spices:
    "https://images.unsplash.com/photo-1606914469725-e398d2f1d7ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  thaliPlatter:
    "https://images.unsplash.com/photo-1589778655375-3e622a9fc91c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  curryBowl:
    "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  saladBowl:
    "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  goldenMilk:
    "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  spiceMarket:
    "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cooking:
    "https://images.unsplash.com/photo-1556910103-1c02745aae4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const CITIES = [
  { id: "delhi_ncr", label: "Delhi NCR" },
  { id: "bengaluru", label: "Bengaluru" },
];
